import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'OopsMessage' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 24,
        flexWrap: 'wrap'
    },
    title: {
        margin: 0,
        padding: 0,
        color: '#F5726A',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '150%',
        flex: 1000,
        minWidth: 320
    },
    action: {
        color: '#fff',
        borderRadius: 12,
        padding: '16px 32px',
        textTransform: 'none',
        background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%) !important',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        flex: '1 1 auto'
    }
});
